import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Vertical } from 'src/app/modules/account/shared/models/vertical-enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
    public prefix: any;
    public group : any;

    public isEquipProvider: boolean= false;
    public dispAmortization$= new BehaviorSubject<boolean>(false);
    public changeAccModalBackground$= new BehaviorSubject<boolean>(true);
   // this.authService.setPortalType((urlFinder.includes('scheinpay') || urlFinder.includes('hspracticepay') || urlFinder.includes('localhost')));
   // this.dentalProviderInActive = this.authService.getPortalType();


    //public externalFinCityWidgetUrl$ = new Subject<string>();
    constructor() { 
         this.prefix = `${environment.ASSETS_CDN_BASE_URL}/`;
         console.log('Service ActiveRoutePath: ' + window.location.pathname);
           // let currentRoute = window.location.pathname
           let urlFinder = window.location.origin;

           console.log('UrlFinder: ' + urlFinder)
          this.setPortalType((urlFinder.includes('scheinpay') || urlFinder.includes('hspracticepay') || urlFinder.includes('localhost') ))
                //this.setPortalType((urlFinder.includes('scheinpay') || urlFinder.includes('hspracticepay')  ))

          // this.setPortalType((urlFinder.includes('scheinpay') || urlFinder.includes('hspracticepay') || urlFinder.includes('localhost')))
          //this.setPortalType((urlFinder.includes('scheinpay') || urlFinder.includes('hspracticepay') ))
           if(this.getPortalType()){
            this.group = "hsfs"
            document?.documentElement?.style.setProperty('--background-color', Vertical.EquipmentProvider)
           }else {
            this.group = "dental"
            document?.documentElement?.style.setProperty('--background-color', Vertical.Dental)
           }
          //  if(currentRoute?.indexOf('hspracticepay') > -1){
          //   this.group = "hsfs"
          //  }else {
          //   this.group = "dental"
          //  }

          //  switch (true) {
          //    case currentRoute?.indexOf('hspracticepay') > -1:
          //      this.group = "hsfs"
          //      break;
          //    default:
          //      this.group = "dental"
          //      break;
          //  } 
    }

    assetsCdn(dir: string) {
        const filename = `${this.group}/${dir}`;
        //console.log('Image Path: ' + filename)
        //console.log(' 111Image Path: ' + this.prefix + filename)
        return this.prefix + filename
    }

    setPortalType(data:boolean){
      this.isEquipProvider = data;
    }

    getPortalType(): boolean{
        return this.isEquipProvider;
    }

    getRoute(){
     return this.group;
    }



}